module.exports = __webpack_public_path__ + "img/image1.1c9d3117.png";